<template>
<!-- 自媒体传播指数---红山网 -->
	<div class="wlmq_ziBroadFiv">
		<div class="seven" > 
			<!-- echarts图--折线 -->
			<div class="zan">
				<div :id="likenumTId" style="width:100%;height:100%;"></div>
			</div>
			<!-- echarts图--柱状 -->
			<div class="fagao" >
				<div :id="fagaoId" style="width:100%;height:100%;"></div>
				<!-- <div :id="fagaoId2" style="width:100%;height:100%;" v-if="radio == 2"></div> -->
			</div>
			<!-- <div class="content">
				<el-radio v-model="radio" label="1" @change="showLine()">十天</el-radio>
				<el-radio v-model="radio" label="2" @change="showLines()">一年</el-radio>
			</div> -->
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	
	import qs from 'qs'
	import echarts from 'echarts'
	export default {
		data() {
			return {
				title: '自媒体传播指数',
				mainArr:['1','2','3','4','5','6','7'],
				checkId:'1',
				//折线图
				// likenumTId:'my',
				likenumTId:'my4'+ this.new_data(),
				likenumT:'',
				like_count:[],
				read_count:[],
				//柱状图
				// fagaoId:'you',
				fagaoId:'you4'+ this.new_data(),
				fagaoId2:'he'+ this.new_data(),
				fagao:'',
				fagaoDataX:[],
				fagaoData:[],
				day:[],
				count:[],
				//单选框
				radio: '1',
				radios: '3',
				showLine0:'true',
				//fangda
				bigIndex:-1,
				bigItem:'',
				show:true,
				big_ref:''
			}
		},
		created(){
			
		},
		mounted() {
			//折线图
			// this.likenumT = echarts.init(document.getElementById(this.likenumTId))
			//柱状图
			// this.fagao = echarts.init(document.getElementById(this.fagaoId))
			
			this.getEcharts()

		},
		methods: {
			getEcharts(){
				axios.get(`${this.BASE_URL.url}lsg/getTransmissionIndex/find.jspx?name=红山眼&type=app`).then(res=>{
					this.day=res.data.data.dateList
					this.like_count=res.data.data.likeList  //uv
					this.read_count=res.data.data.readList
					this.count=res.data.data.countList
					
					this.showFagao(this.day,this.count)	//柱状图		
					this.showLikenum(this.day,this.like_count,this.like_count)	//折线
				}).catch(e=>{
				
				})
				/*axios.get(`${this.BASE_URL.url}lsg/interface/wxAnalysisDataFor.jspx?userId=370&pageNum=1&pageSize=21&groupName=%E4%B9%8C%E6%9C%A8%E9%B2%81%E9%BD%90%E5%BE%AE%E4%BF%A1%E5%A4%A7%E5%B1%8F&range=15d`).then(res=>{
					//zhe
					var arr=res.data.goodRed[4]
					//zhu
					this.day=res.data.sevenDay[4].day
					this.wci=res.data.sevenDay[4].wci
					// this.showLikenum(this.day)	//折线
					axios.get(`${this.BASE_URL.url}lsg/interface/sevenCount.jspx?type=app`).then(res=>{
						//zhe
						this.like_count=res.data.list[0].like_count.split(",")
						this.read_count=res.data.list[0].read_count.split(",")
						this.count=res.data.list[0].count.split(",")
		
						this.showFagao(this.day,this.count)	//柱状图
						this.showLikenum(this.day,this.like_count,this.like_count)	//折线
					}).catch(e=>{
					
					})
				}).catch(e=>{
					
					})*/
				// this.fagao.clear()
				// this.showLikenum()	//折线
			},
			//十天 一年
			showLine(){ //十天
				this.showLine0='true'
				this.getEcharts()
				// console.log(this.radio)
			},
			showLines(){ //一年
				this.showLine0='false'
				this.getEcharts()
				// console.log(this.radio)
			},
			//echarts自适应
			resize(){
				this.likenumT.resize()
				this.fagao.resize()
			},
			//柱状图
			showFagao(a,b){
			this.fagao = echarts.init(document.getElementById(this.fagaoId))

				var option  = {
					title:{
						text:'发稿量',
						textStyle:{
							color:'#05FFFF',
							fontWeight: 'lighter',
							fontSize: 14,
						}
					},
					tooltip : {
						trigger: 'axis',
						axisPointer : {            // 坐标轴指示器，坐标轴触发有效
							type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
						}
					},
					grid: {
						left: '2%',
						right: '2%',
						top:'25%',
						bottom: '5%',
						containLabel: true
					},
					xAxis : [{
						type : 'category',
						data : a,
						axisTick: {
							show:false,
							alignWithLabel: true,
							lineStyle:{
								color:'#fff',
							}
						},
						axisLine:{
							lineStyle:{
								color:'#fff',
							}
						},
						axisLabel:{ //坐标轴刻度标签
							interval:0,//横轴信息全部显示  
							rotate:40,//-30度角倾斜显示
						}
					}],
					yAxis : [
						{
							type : 'value',
							axisTick: {
								show:false,
								alignWithLabel: true,
								lineStyle:{
									color:'#fff',
								}
							},
							axisLine:{
								show:false,
								lineStyle:{
									color:'#fff',
								}
							},
							splitLine:{
								lineStyle:{
									color:['#2D3A4E'],
									type:'dashed'
								}
							}
						}
					],
					series : [{
							// name:'直接访问',
							type:'bar',
							barWidth: '60%',
							itemStyle:{
								normal:{
									color: '#00A2FF',
								}
							},
							label: {
								normal: {
									show: true,
									position: 'top'
								}
							},
							data:this.count
						}
					]
				};
				this.fagao.setOption(option)
				const self = this;
				self.fagao.on('mousemove', function(){
					return false;
				})
				window.addEventListener('resize',function(){
					self.fagao.resize()
				});
			},
			//折线图
			showLikenum(){
			this.likenumT = echarts.init(document.getElementById(this.likenumTId))

				var option = {
					title:{
						text:'点赞量 阅读量',
						textStyle:{
							color:'#05FFFF',
							fontWeight: 'lighter',
							fontSize: 14,
						}
					},
					legend: {
						textStyle:{color:'#fff'},
						right:'right',
						width:'50%',
						top:'top',
						orient: 'horizontal',
						data:[{
							name:'点赞量',
							icon:'circle'
						},{
							name:'阅读量',
							icon:'circle'
						}]
					},
					grid:{
						x:15, //左
						y:35, //上
						x2:5,
						y2:10,
						borderWidth:1
					},
					tooltip : {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					xAxis: {
						type: 'category',
						show:false,
						boundaryGap: false,
						data:this.day
					},
					yAxis: {
						show:false,
						type: 'value'
					},
					series: [{
						name:'点赞量',
						data:this.like_count,
						type: 'line',
						color:'#3AA3FF',
						label:{
							color:'#fff',
							formatter: '{b}: {c}'
						},
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#4C83E0'
							}, {
								offset: 1,
								color: '#081B37',
								opacity:0
							},]),
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#081B37',
								opacity:0
							}, {
								offset: 1,
								color: 'transparent'
							},]),
							// origin:'start',
						},
					},{
						name:'阅读量',
						data: this.read_count,
						type: 'line',
						color:'#C720E0',
						areaStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#081B37',
								opacity:0
							}, {
								offset: 1,
								color: 'transparent'
							},]),
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#4C83E0'
							}, {
								offset: 1,
								color: '#081B37',
								opacity:0
							},]),
						},
					}]
				};
				this.likenumT.setOption(option)
				const self = this;
				self.likenumT.on('mousemove', function(){
					return false;
				})
				window.addEventListener('resize',function(){
					self.likenumT.resize()
				});
			},
			//echarts的id
			new_data(){
				var myDate = new Date()//获取系统当前时间
				var i = myDate.getTime() //getTime() 返回从 1970.0.0至今的毫秒数
				return i
			},
		}
	}
</script>

<style lang="scss">
	.wlmq_ziBroadFiv{
		.main{
			.seven{
				.content{
					.el-radio {  //未选中文字颜色
						color: #fff;
					}
					.el-radio+.el-radio { //按钮距离
						margin-left: 18px;
					}
					.el-radio__inner { //圆按钮大小
						width: 12px;
						height: 12px;
					}
					.el-radio__label { //文字大小
    					font-size: 12px;
						padding-left: 5px;//按钮和文字间距离
					}
				}
			}
		}
	}
</style>

<style scoped lang="scss">
	.wlmq_ziBroadFiv{
		width:100%;
		height: 100%;
		.seven{
			margin-right: 1.3%;
			margin-bottom:1.9vh;
			position: relative;
			.top{
				width: 100%;
				height: 3.6vh;
				line-height: 3.6vh;
				display: flex;
				justify-content: space-between;
				.sevenName{
					font-weight: bold;
					color: deepskyblue;
					margin: 0.5vh 4% 0;
					width: 35%;
					height: 3vh;
					line-height: 3vh;
					font-size: 0.94vw;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.btn{
					width: 16%;
					margin-top: 0.2vh;
					.btn-box{
						border: 1px solid #0078d7;
						border-radius: 50%;
						width: 1.2vw;
						height: 1.2vw;				    	
						display: inline-flex;
						cursor: pointer;
						justify-content: center;
						align-items: center;	    		
						.iconfont{				    			
							color: #0374de;	
							font-size: 0.7vw;	    			
							position: relative;
							top: 1px;
						}			    		
					}
					.activeIcon{
						background:#009AFB;
						color:#fff;
						.iconfont{
							color:#fff;
						}
					}	
				}
			}
			.zan,.fagao{
				width: 92%;
				height: 14vh;
				margin: 1vh 4%;
			}
			.fagao{
				margin-top: 2vh;
				height: 18vh;
			}
			.content{
				position: absolute;
				top: 16vh;
				right: 5%;
			}
		}
	}
	.show-big{
		.wlmq_ziBroadFiv{
			margin:11vh 11% !important;
			width:75% !important;
			height: 74% !important;
			.seven{
				height: 100% !important;
				.zan{
					height: 32vh !important;
				}
				.fagao{
					height: 33vh !important;
				}
				.content{
					top:36vh !important;
				}
			}
		}
	}
</style>